<script>
	import { onMount } from "svelte";
    import Modal from 'svelte-simple-modal';
	import Navbar from "../Components/Navbar/Navbar.svelte";
	import Footer from "../Components/Footer/Footer.svelte";
	import Home from "../Components/Home/Home.svelte";

	import DATA from "../Data/data";

	import { store } from '../store.js';
	import NavbarMobile from "../Components/Navbar/NavbarMobile.svelte";
	import HomeMobile from "../Components/Home/HomeMobile.svelte";
	import FooterMobile from "../Components/Footer/FooterMobile.svelte";
	
	let loaded = false;

	const pageName = 'main';

	let iw, ow;
	let img;
	
	onMount(() => {
		loaded = true;
	});

	function updateBackground() {
		if(!img || !img.src.includes(`${$store.type}`)) {
			img = new Image();
			img.onload = function() {
				store.update(s => ({...s, imageWidth: this.width, imageHeight: this.height}))
			}
			img.src = `/images/${pageName}-${$store.type}.png`;
		}

	}
	
	onMount(() => {		
		updateBackground();

		window.addEventListener('resize', updateBackground);
		
		return () => {
			window.removeEventListener('resize', updateBackground);
		}
	});
</script>
<svelte:window  bind:innerWidth={iw} bind:outerWidth={ow} />

<Modal styleContent={{padding: 0}} styleWindow={{width: '30rem'}}>
	{#if loaded}
	<div style={
		$store.type === 'pc' ? 
		`background: linear-gradient(90deg, rgb(48 197 194) 0%, rgb(86 208 205) 28%, rgb(230 248 247) 59%, rgba(248,253,253,1) 79%, rgba(252,253,253,1) 100%);`
		:
		`background: linear-gradient(90deg, rgb(48 197 194) 0%, rgb(69 203 200) 28%, rgb(89 209 206) 59%, rgb(104 213 210) 79%, rgb(107 213 211) 100%);`
	}>
		<div 
			class="wrapper" 
			class:dev={$store.isDev}
			style={
				`background: url(/images/main-${$store.type}.png) no-repeat;
				background-size: 100% ${$store.imageHeight * $store.r}px;
				height: ${$store.imageHeight * $store.r + 200}px;
				`
			}
		>	
		
			{#if $store.type === 'pc'}
				<Navbar logo={true} navlists={DATA.NAVBAR_DATA} header={DATA.HEADER} />
				<Home />
				<Footer footerData={DATA.FOOTER_DATA} />
			{:else}
				<NavbarMobile logo={true} navlists={DATA.NAVBAR_DATA} header={DATA.HEADER} />
				<HomeMobile />
				<FooterMobile footerData={DATA.FOOTER_DATA} />
			{/if}
		
		</div>
	</div>
	{/if}
</Modal>


<style>
	
</style>
